module.exports = __webpack_public_path__ + "static/people_pop28-ffa317a79ad5b664caafb88d765ae4ae.png";